import { render, staticRenderFns } from "./DueDiligence.vue?vue&type=template&id=d9991fbc&"
import script from "./DueDiligence.vue?vue&type=script&lang=js&"
export * from "./DueDiligence.vue?vue&type=script&lang=js&"
import style0 from "./DueDiligence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9991fbc')) {
      api.createRecord('d9991fbc', component.options)
    } else {
      api.reload('d9991fbc', component.options)
    }
    module.hot.accept("./DueDiligence.vue?vue&type=template&id=d9991fbc&", function () {
      api.rerender('d9991fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entities/tabs/DueDiligence.vue"
export default component.exports